"use client";

import { useState, useEffect } from "react";
import Link from "next/link";

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted or declined cookies
    const consent = localStorage.getItem("cookieConsent");
    if (!consent) {
      // Short delay before showing the banner
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1200); // slightly longer delay for subtlety
      return () => clearTimeout(timer);
    }
  }, []);

  // Helper to update Google Consent Mode
  const updateConsentMode = (granted: boolean) => {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("consent", "update", {
        analytics_storage: granted ? "granted" : "denied",
        ad_storage: granted ? "granted" : "denied",
      });
    }
  };

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    updateConsentMode(true);
    setIsVisible(false);
  };

  const declineCookies = () => {
    localStorage.setItem("cookieConsent", "declined");
    updateConsentMode(false);
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="fixed bottom-2 left-0 right-0 z-50 flex justify-center pointer-events-none">
      <div className="pointer-events-auto bg-white/80 border border-slate-200 rounded-lg px-4 py-2 flex flex-col sm:flex-row sm:items-center gap-2 max-w-md w-full mx-2 sm:mx-0 shadow-sm">
        <div className="flex-grow">
          <p className="text-xs sm:text-sm text-slate-600">
            We use cookies for a better experience.{" "}
            <Link href="/cookie-policy" className="text-[#287e6f] underline ml-1">
              Learn more
            </Link>
          </p>
        </div>
        <div className="flex-shrink-0 flex gap-1 sm:gap-2">
          <button
            onClick={acceptCookies}
            className="py-1 px-3 bg-[#287e6f] text-white text-xs sm:text-sm rounded hover:bg-[#1e665a] transition-colors"
          >
            Accept
          </button>
          <button
            onClick={declineCookies}
            className="py-1 px-3 bg-slate-100 text-slate-600 text-xs sm:text-sm rounded border border-slate-200 hover:bg-slate-200 transition-colors"
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
} 